import { css } from 'lit';
export default css `
  h2 {
    margin: 0;
    padding: 0;
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    letter-spacing: -0.2px;
  }
`;
//# sourceMappingURL=styles.js.map